import React, { FC } from "react";
import { Accordion, AccordionSummary, Grid, Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { trafficLight } from "../../theme";




const NoDamInfo: FC = () => {
    return (
        <div style={{padding:"10px"}}>
            <Paper variant={"outlined"} style={{height:"250px", display:'flex', alignItems:'center', justifyContent:"center"}}>
                <div>There are no dams currently selected</div>
            </Paper>

        </div>
    )

}

export default NoDamInfo;